import React from "react";
import { useTranslation } from "react-i18next";

const NoData = (props) => {
  const {t} = useTranslation()
  return (
    <div className="text-center mb-4">
      {props.count ? <></> : <h6 className="mt-5" style={{padding:"67px 10px"}}>{props.text??t("no-data")}</h6>}
    </div>
  );
};

export default NoData;
